import * as React from "react";

export default class BtnPesquisar extends React.Component {
    render() {
        return <button type={this.props.type} className={(this.props.isLoading) ? "btn btn-dark" : "btn btn-cyan"} disabled={this.props.isLoading ? true : false}>
            <i className="fa fa-search"></i>
            {(this.props.isLoading) ? this.props.textLoading : this.props.text}
        </button>;
    }
}